import { RequiredQueryKeyFilter, createDefaultQueryKeysGenerator } from 'core/query/constants';

interface RealmQueryDetailKeyFilter extends RequiredQueryKeyFilter {
  realmId: string;
  tenant?: string;
}

type RealmQueryListKeyFilter = RequiredQueryKeyFilter;

export const realmQueryKeys = createDefaultQueryKeysGenerator<
  RealmQueryListKeyFilter,
  RealmQueryDetailKeyFilter
>({
  keyDataType: 'realms',
});
